var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',[_c('b-table',{attrs:{"items":_setup.enrollmentItems,"fields":_setup.FIELDS,"table-class":"table-minimal","show-empty":""},scopedSlots:_vm._u([{key:"cell(value)",fn:function(data){return [_vm._v(" "+_vm._s(_setup.getEnrollmentValue(data.item))+" ")]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }